import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  classroomPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentClassroom: {},
  classroomReaderPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentClassroomReader: {},
  classroomTeacherPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentClassroomTeacher: {},
});

const setClassroomsReducer = (state, action) => setRecordsReducer('classroom', state, action);

const setCurrentClassroomPageReducer = (state, action) => setCurrentRecordPageReducer('classroom', state, action);

const setCurrentClassroomReducer = (state, action) => setCurrentRecordReducer('classroom', state, action);

const clearClassroomsAfterPageReducer = (state, action) => clearRecordsAfterPageReducer('classroom', state, action);

const setClassroomReadersReducer = (state, action) => setRecordsReducer('classroomReader', state, action);

const setCurrentClassroomReaderPageReducer = (state, action) =>
  setCurrentRecordPageReducer('classroomReader', state, action);

const setCurrentClassroomReaderReducer = (state, action) => setCurrentRecordReducer('classroomReader', state, action);

const clearClassroomReadersAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('classroomReader', state, action);

const setClassroomTeachersReducer = (state, action) => setRecordsReducer('classroomTeacher', state, action);

const setCurrentClassroomTeacherPageReducer = (state, action) =>
  setCurrentRecordPageReducer('classroomTeacher', state, action);

const setCurrentClassroomTeacherReducer = (state, action) => setCurrentRecordReducer('classroomTeacher', state, action);

const clearClassroomTeachersAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('classroomTeacher', state, action);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.SET_CLASSROOMS:
      return setClassroomsReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_PAGE:
      return setCurrentClassroomPageReducer(state, action);
    case types.SET_CURRENT_CLASSROOM:
      return setCurrentClassroomReducer(state, action);
    case types.CLEAR_CLASSROOMS_AFTER_PAGE:
      return clearClassroomsAfterPageReducer(state, action);
    // Classroom Student
    case types.SET_CLASSROOM_READERS:
      return setClassroomReadersReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_READER_PAGE:
      return setCurrentClassroomReaderPageReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_READER:
      return setCurrentClassroomReaderReducer(state, action);
    case types.CLEAR_CLASSROOM_READERS_AFTER_PAGE:
      return clearClassroomReadersAfterPageReducer(state, action);
    // Classroom Teacher
    case types.SET_CLASSROOM_TEACHERS:
      return setClassroomTeachersReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_TEACHER_PAGE:
      return setCurrentClassroomTeacherPageReducer(state, action);
    case types.SET_CURRENT_CLASSROOM_TEACHER:
      return setCurrentClassroomTeacherReducer(state, action);
    case types.CLEAR_CLASSROOM_TEACHERS_AFTER_PAGE:
      return clearClassroomTeachersAfterPageReducer(state, action);
    default:
      return state;
  }
};
